// src/pages/DfyPage.jsx
import React from "react";
import "../components/Navbar.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const dfy = () => {
  async function handleDfyCheckout() {
    try {
      const res = await fetch(`${API_BASE_URL}/create-dfy-checkout-session`, {
        method: "POST",
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Failed to create DFY checkout session:", text);
        alert("Failed to create DFY checkout session");
        return;
      }

      const data = await res.json();

      if (!data.url) {
        console.error("No URL returned from DFY checkout session:", data);
        alert("Unexpected error starting checkout.");
        return;
      }

      // New Stripe.js behavior: just redirect to the URL the Session gives you
      window.location.href = data.url; // or window.location.assign(data.url);
    } catch (err) {
      console.error("Error creating DFY checkout session", err);
      alert("Error creating DFY checkout session");
    }
  }

  return (
    <>
      <Navbar />
      <div
        className="dfy-page"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* Hero Section */}
        <section
          className="dfy-hero"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: "4rem 1.5rem 2rem 1.5rem",
          }}
        >
          <h1
            className="dfy-hero-title"
            style={{
              fontSize: "2.5rem",
              fontWeight: 700,
              color: "#0f172a",
              marginBottom: "1rem",
            }}
          >
            Done-For-You Automated Reports for Small Businesses
          </h1>
          <p
            className="dfy-hero-subtext"
            style={{
              fontSize: "1.05rem",
              lineHeight: 1.7,
              color: "#475569",
              maxWidth: "720px",
            }}
          >
          Taren doesn&apos;t just crunch your numbers — it blends{" "}
          <strong>machine-learning analysis with real human oversight</strong> to turn
          your data into simple weekly reports you can actually use.
          Export your data from tools you already rely on (Excel or Google Sheets
          exports, Square, Shopify, Stripe, QuickBooks, etc.), send them to us,
          and get back clear, human-reviewed insight summaries that explain what&apos;s
          working, what&apos;s slipping, and what needs your attention next.
          </p>

          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            <button
              className="dfy-primary-button"
              style={{
                padding: "0.85rem 1.6rem",
                borderRadius: "999px",
                border: "none",
                background: "#4f46e5",
                color: "white",
                fontWeight: 600,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(79,70,229,0.25)",
              }}
              onClick={handleDfyCheckout}
            >
              Start Automated Reports
            </button>

            <button
              className="dfy-secondary-button"
              style={{
                padding: "0.85rem 1.6rem",
                borderRadius: "999px",
                border: "1px solid #cbd5f5",
                background: "white",
                color: "#1e293b",
                fontWeight: 500,
                cursor: "pointer",
              }}
              onClick={() => {
                const el = document.getElementById("dfy-sample-section");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              View sample report
            </button>
          </div>
        </section>

        {/* Who It's For */}
        <section
          className="dfy-who-for"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: "1rem 1.5rem 2.5rem 1.5rem",
          }}
        >
          <h2
            style={{
              fontSize: "1.6rem",
              fontWeight: 600,
              color: "#0f172a",
              marginBottom: "1.5rem",
            }}
          >
            Built for owners who don&apos;t have time to live in spreadsheets
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: "1.5rem",
            }}
          >
            <div
              className="dfy-card"
              style={{
                background: "white",
                borderRadius: "1rem",
                padding: "1.25rem 1.4rem",
                boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
                border: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  color: "#0f172a",
                }}
              >
                Solo business owners & freelancers
              </h3>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#64748b",
                  lineHeight: 1.6,
                }}
              >
                You&apos;re wearing every hat. Instead of spending nights trying
                to interpret spreadsheets, get a simple report that tells you how
                your revenue, costs, and cash are actually trending.
              </p>
            </div>

            <div
              className="dfy-card"
              style={{
                background: "white",
                borderRadius: "1rem",
                padding: "1.25rem 1.4rem",
                boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
                border: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  color: "#0f172a",
                }}
              >
                Local service businesses
              </h3>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#64748b",
                  lineHeight: 1.6,
                }}
              >
                Salons, studios, trades, clinics, and more. Send the exports you
                already get from your POS or booking tools and receive an easy,
                repeatable view of daily and weekly performance.
              </p>
            </div>

            <div
              className="dfy-card"
              style={{
                background: "white",
                borderRadius: "1rem",
                padding: "1.25rem 1.4rem",
                boxShadow: "0 10px 30px rgba(15,23,42,0.05)",
                border: "1px solid #e2e8f0",
              }}
            >
              <h3
                style={{
                  fontWeight: 600,
                  marginBottom: "0.5rem",
                  color: "#0f172a",
                }}
              >
                Online shops & recurring revenue
              </h3>
              <p
                style={{
                  fontSize: "0.95rem",
                  color: "#64748b",
                  lineHeight: 1.6,
                }}
              >
                Selling through Shopify, Stripe, or subscription platforms?
                Export your order or revenue reports and get back a clear story
                on growth, churn, and where money is leaking.
              </p>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section
          className="dfy-how-it-works"
          style={{
            background: "#0f172a",
            padding: "3rem 1.5rem",
          }}
        >
          <div style={{ maxWidth: "900px", margin: "0 auto" }}>
            <h2
              style={{
                fontSize: "1.7rem",
                fontWeight: 600,
                color: "white",
                marginBottom: "1.5rem",
              }}
            >
              How the Done-For-You flow works
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  background: "#020617",
                  borderRadius: "1rem",
                  padding: "1.25rem 1.4rem",
                  border: "1px solid rgba(148,163,184,0.35)",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    fontWeight: 600,
                    marginBottom: "0.4rem",
                  }}
                >
                  1. Sign up & get your upload instructions
                </h3>
                <p
                  style={{
                    color: "#cbd5f5",
                    fontSize: "0.95rem",
                    lineHeight: 1.6,
                  }}
                >
                  After checkout, you&apos;ll receive a short welcome email with
                  your dedicated upload instructions and where to send your daily
                  or weekly exports.
                </p>
              </div>
              <div
                style={{
                  background: "#020617",
                  borderRadius: "1rem",
                  padding: "1.25rem 1.4rem",
                  border: "1px solid rgba(148,163,184,0.35)",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    fontWeight: 600,
                    marginBottom: "0.4rem",
                  }}
                >
                  2. Send the reports you already export
                </h3>
                <p
                  style={{
                    color: "#cbd5f5",
                    fontSize: "0.95rem",
                    lineHeight: 1.6,
                  }}
                >
                  Email the same Excel or Google Sheets exports, POS reports
                  (Square, Clover), ecommerce exports (Shopify), or accounting
                  reports (QuickBooks, Xero) you&apos;re already pulling. No new
                  tools, no integrations, no extra setup.
                </p>
              </div>
              <div
                style={{
                  background: "#020617",
                  borderRadius: "1rem",
                  padding: "1.25rem 1.4rem",
                  border: "1px solid rgba(148,163,184,0.35)",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    fontWeight: 600,
                    marginBottom: "0.4rem",
                  }}
                >
                  3. Receive clear, recurring insight reports
                </h3>
                <p
                  style={{
                    color: "#cbd5f5",
                    fontSize: "0.95rem",
                    lineHeight: 1.6,
                  }}
                >
                  Taren reads the data, spots trends, and explains what changed
                  in plain English. You get a polished report you can skim in a
                  few minutes and actually act on — daily or weekly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Sample & What You Get */}
        <section
          id="dfy-sample-section"
          className="dfy-sample-section"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            padding: "3rem 1.5rem 2rem 1.5rem",
          }}
        >
          <h2
            style={{
              fontSize: "1.6rem",
              fontWeight: 600,
              color: "#0f172a",
              marginBottom: "1rem",
            }}
          >
            What&apos;s inside an automated insight report?
          </h2>
          <p
            style={{
              fontSize: "0.98rem",
              color: "#475569",
              maxWidth: "720px",
              lineHeight: 1.7,
              marginBottom: "1.5rem",
            }}
          >
            Each report is designed so you don&apos;t have to translate the
            numbers. No dashboards, no extra explanation — just a clear story
            about what&apos;s happening in your business and what to watch next.
          </p>

          {/* Demo video */}
          <div
            style={{
              marginBottom: "1.75rem",
              borderRadius: "1rem",
              overflow: "hidden",
              boxShadow: "0 16px 40px rgba(15,23,42,0.15)",
              background: "#0f172a",
            }}
          >
            <video className="landing-video" controls autoPlay muted loop>
              <source src="/ReportDemoVid.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          <ul
            style={{
              listStyle: "disc",
              paddingLeft: "1.4rem",
              color: "#0f172a",
              fontSize: "0.96rem",
              lineHeight: 1.7,
              marginBottom: "1.5rem",
            }}
          >
            <li>Revenue and margin trends with plain-English explanations</li>
            <li>Top performing and underperforming services or products</li>
            <li>Customer or segment insights (who&apos;s driving growth, who&apos;s risky)</li>
            <li>Simple visuals that make patterns obvious at a glance</li>
            <li>Clear callouts when something looks off or needs attention</li>
            <li>1–3 recommended actions for the upcoming days or week</li>
          </ul>

          <button
            className="dfy-primary-button"
            style={{
              padding: "0.8rem 1.5rem",
              borderRadius: "999px",
              border: "none",
              background: "#4f46e5",
              color: "white",
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 10px 30px rgba(79,70,229,0.2)",
            }}
            onClick={handleDfyCheckout}
          >
            Start Automated Reports
          </button>
        </section>

        {/* Pricing */}
        <section
          className="dfy-pricing"
          style={{
            borderTop: "1px solid #e2e8f0",
            background: "white",
            padding: "2.5rem 1.5rem 3rem 1.5rem",
          }}
        >
          <div style={{ maxWidth: "900px", margin: "0 auto" }}>
            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: 600,
                color: "#0f172a",
                marginBottom: "0.75rem",
              }}
            >
              Simple, small-business friendly pricing
            </h2>
            <p
              style={{
                fontSize: "0.98rem",
                color: "#64748b",
                maxWidth: "720px",
                lineHeight: 1.7,
                marginBottom: "1.75rem",
              }}
            >
              No tiers, no add-ons, no setup fees. One clear price for your
              business so you can stop guessing and start tracking what actually
              matters — without hiring a full-time analyst.
              <br /><br />
              Want this done automatically every week? Grab the link in your welcome email to connect your data!
            </p>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
                gap: "1.5rem",
              }}
            >
              <div
                style={{
                  background: "#0f172a",
                  borderRadius: "1.2rem",
                  padding: "1.75rem 1.6rem",
                  color: "white",
                  boxShadow: "0 18px 40px rgba(15,23,42,0.25)",
                  border: "1px solid rgba(148,163,184,0.6)",
                }}
              >
                <p
                  style={{
                    fontSize: "0.8rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.12em",
                    color: "#a5b4fc",
                    marginBottom: "0.4rem",
                  }}
                >
                  Automated DFY Reports
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "0.3rem",
                    marginBottom: "0.75rem",
                  }}
                >
                  <span
                    style={{
                      fontSize: "2.1rem",
                      fontWeight: 700,
                    }}
                  >
                    $49.99
                  </span>
                  <span
                    style={{
                      fontSize: "0.95rem",
                      color: "#e5e7eb",
                    }}
                  >
                    / month
                  </span>
                </div>
                <p
                  style={{
                    fontSize: "0.9rem",
                    color: "#cbd5f5",
                    marginBottom: "1.1rem",
                  }}
                >
                  For solo businesses that want clear, recurring insight on their
                  numbers without touching another spreadsheet.
                </p>

                <ul
                  style={{
                    listStyle: "none",
                    paddingLeft: 0,
                    margin: "0 0 1.3rem 0",
                    fontSize: "0.9rem",
                    color: "#e5e7eb",
                    lineHeight: 1.7,
                  }}
                >
                  <li>✔ Daily or weekly summary reports (your choice)</li>
                  <li>✔ Support for common exports (Excel, Sheets, POS, ecommerce)</li>
                  <li>✔ Trend and anomaly callouts you can act on quickly</li>
                  <li>✔ Email support if you have questions about a report</li>
                  <li>✔ Cancel anytime — no long-term contracts</li>
                </ul>

                <button
                  className="dfy-primary-button"
                  style={{
                    width: "100%",
                    marginTop: "0.5rem",
                    padding: "0.9rem 1.5rem",
                    borderRadius: "999px",
                    border: "none",
                    background:
                      "linear-gradient(135deg, #38bdf8, #4f46e5, #a855f7)",
                    color: "white",
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: "0 14px 35px rgba(37,99,235,0.6)",
                  }}
                  onClick={handleDfyCheckout}
                >
                  Start for $49.99 / month
                </button>
              </div>

              <div
                style={{
                  alignSelf: "center",
                  fontSize: "0.95rem",
                  color: "#475569",
                  lineHeight: 1.7,
                }}
              >
                <p style={{ marginBottom: "0.9rem" }}>
                Most owners lose far more than this every month—missed warning signs, late
                decisions, and hours buried in spreadsheets. We give you a repeatable way to
                stay ahead of your numbers so problems surface instantly, not weeks later.
                </p>
                <p style={{ marginBottom: "0.9rem" }}>
                Cancel anytime. If it doesn’t save you time or improve decisions, don’t pay for
                it — we wouldn’t want you to.
                </p>
                <p style={{ fontSize: "0.85rem", color: "#64748b" }}>
                  After checkout you&apos;ll get an email with upload
                  instructions and your first step to send us data. We&apos;ll
                  take it from there.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default dfy;
